div.no-results {
	padding: 80px 0px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	flex-basis: 100%;
}

.no-results-img {
	width: min(215px, 80%);
}

p.no-results-p {
	text-align: center;
	font-size: 15px;
	margin: 16px 0;
}
